<template>
    <div class="search-new">
        <div class="search-new-search_input">
            <van-search
                ref="search_input"
                v-model="searchText"
                :autofocus="autofocus"
                show-action
                clear-trigger="always"
                @input="mInput"
                @cancel="onCancel"
                @search="onSearch"
                placeholder="搜一搜"
            >
               <template v-slot:left-icon>
                    <img src="/static/v4/search_icon.svg" alt="" style="margin-top: 2px" />
                </template>
                <template slot="action">
                    <div class="search-list-btn" @click="onSearch">搜索</div>
                </template>
            </van-search>
        </div>
        <!--历史搜索 -->
        <div class="search-new-history" v-if="showHistory">
            <div class="search-new-history-title">
                <div class="search-new-history-title-left">
                    <span>历史搜索</span>
                </div>
                <div class="search-new-history-title-right" @click="delDialog = true">
                    <span>清空</span>
                    <img src="/static/v4/search_delete.svg" alt="" />
                </div>
            </div>
            <div class="search-new-history-content">
                <div class="search-new-history-content-top" :class="[textToggle ? '' : 'active']" ref="historyRef">
                    <span
                        v-for="(item, index) in historyTag"
                        :key="index"
                        ref="tagRef"
                        @click="clickTag(item)"
                        :class="[item.title === '展开' || item.title === '收起' ? 'chu' : '']"
                        v-if="item.title"
                    >
                        {{ item.title }}
                        <img v-if="item.title === '展开'" src="/static/v4/more_down.svg" alt="" />
                        <img v-if="item.title === '收起'" src="/static/v4/more_up.svg" alt="" />
                    </span>
                </div>
            </div>
        </div>
        <!--搜索结果 -->
        <div class="search-new-result" v-if="showResult">
            <van-tabs v-model="searchIndex" @click="tabClick">
                <van-tab v-for="(item, index) in searchClassifyArr" :title="item.name" :key="index" :name="index" :title-class="index == searchClassifyArr.length - 1 ? 'van-last' : ''"></van-tab>
            </van-tabs>
            <van-list v-model="resultLoading" :finished="resultFinished" finished-text="没有更多了" @load="onLoad">
                <contentSelection :dataItem="recommend" :posType="2"/>
            </van-list>
        </div>
        <!--搜索结果为空 -->
        <div class="search-new-empty" v-if="searchResultEmpty">
            <div class="search-new-empty-image">
                <img src="/static/img/pic_blank_search.svg"/>
            </div>
            <div class="search-new-empty-desc1">
                换个词，搜搜看
            </div>
            <div class="search-new-empty-back">
                <span @click="$router.push('/')">返回首页</span>
            </div>
        </div>
        <!--热门搜索 -->
       <div class="search-new-hot" v-if="showHot">
            <div class="search-new-hot-title">
                <img src="/static/v4/title_search_hot.svg" />
            </div>
            <div class="search-new-hot-content">
                <div class="search-new-hot-content-item" v-for="(item,index) in hotArr" :key="index"
                     :class="[index > 1 ? 'active' : '']" @click="clickHot(item)">
                    <div class="search-new-hot-content-item-left">
                        <span :class="[index < 3 ? 'span'+index : 0]">{{ index + 1 }}</span>
                    </div>
                    <div class="search-new-hot-content-item-right">
                        <span>{{ item.title }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!--内容推荐 -->
        <div class="search-new-content" v-if="contentShow">
            <div class="search-new-content-title">
                内容精选
            </div>
            <div class="search-new-content-list">
                <van-list
                    v-model="contentLoading"
                    :finished="contentFinished"
                    finished-text="已到底部"
                    @load="contentLoad"
                >
                    <contentSelection :dataItem="contentList" :posType="2"/>
                </van-list>
            </div>
        </div>
        <!--搜索列表 本期不显示 -->
       <div class="search-new-list" v-if="showList">
            <ul>
                <li v-for="(item, index) in searchList" :key="index" @click="selectItem(item)">
                    <img src="/static/bytx/search_icon.svg" alt="" />
                    <span>{{ item.title }}</span>
                </li>
            </ul>
        </div>
        <van-dialog
            v-model="delDialog"
            className="mDialog"
            title="提醒"
            message="确定删除全部历史记录吗？"
            :showCancelButton="true"
            @confirm="delConfirm"
        ></van-dialog>
        <Back bottom="14vh"></Back>
    </div>
</template>

<script>
import Interface from "@/util/interface"
import contentSelection from "@/components/contentSelection/index.vue";
import Back from '@/components/back'
export default {
    name: "search-new",
    components: {
        contentSelection,
        Back,
    },
    data() {
        return {
            searchText: '',
            autofocus: false, // 是否自动聚焦
            historyTag: [],
            textToggle: true,
            showToggle: false,
            delDialog: false,
            hotArr: [],
            searchList: [],
            searchIndex:-1,
            showList: false,
            searchResultEmpty: false,
            searchClassify: null,
            searchClassifyArr: [
                { id: 1, name: '全部' },
                { id: 2, name: '抗癌百科' },
                { id: 3, name: '医疗服务' },
                { id: 4, name: '公益救助' },
                { id: 5, name: '战友故事' },
                { id: 6, name: '看直播' }
            ],
            showResult: false,
            recommend: [],
            title: '',
            toggleTop: 0,
            line: 0,
            hideIndex: 0,
            resultLoading: false,
            resultFinished: false,
            resultPage: 1,
            refreshing: false,
            showHot: false,
            showHistory: false,
            contentList: [],
            contentLoading: false,
            contentFinished: false,
            contentPage: 0,
            contentShow: true,
            searchObj: {}, // 从首页传的底纹词对象
            recordFlag: true  // 点搜索方法是否调记录接口  点击热门搜索  历史记录需要调
        }
    },
    methods: {
        init() {
            let params = {
                type: 1,
                time: new Date().getTime()
            }
            Interface.getData('get', Interface.v4.search_list, params).then(res => {
                if (res.code == 0) {
                    if (res.data.histories && res.data.histories.length) {
                        this.historyTag = res.data.histories.length > 10 ? res.data.histories.splice(0,10) :
                            res.data.histories
                    }
                    if (res.data.hot_words && res.data.hot_words.length ) {
                        this.hotArr = res.data.hot_words.length > 6 ? res.data.hot_words.splice(0,6) :
                            res.data.hot_words
                    }

                    if (this.historyTag && this.historyTag.length) {
                        this.showHistory = true
                    }
                    this.defaultClose()
                    if (this.hotArr.length > 0) {
                        this.showHot = true
                    }
                }
            })
        },
        onSearch() {

            if (!this.searchText) {
                this.$toast.fail('请输入搜索词')
                return
            }

            if(this.searchText == "高博内训学术专区"){
                this.$router.push({
                    name:"live-study"
                })
                return
            }

            if (this.searchObj.title && this.searchObj.title == this.searchText) {
                if (this.searchObj.content_type == 2) {
                    Interface.getData('get', Interface.v4.search_record, {keyword: this.searchText}).then((res) => {

                    })
                    window.location.href = this.searchObj.link
                    return
                }
            }

            this.showList = false
            this.historyTag = []
            let searchClassify = null
            // 获取搜索分类
            Interface.getData('get', Interface.v4.searchClassify, {keyword: this.searchText}).then(res => {
                if (res.code == 0) {
                    this.searchClassifyArr = res.data && res.data.length ? res.data : []
                    if (this.searchClassifyArr && this.searchClassifyArr.length) {
                        searchClassify = this.searchClassifyArr[0].type
                        this.searchClassify = searchClassify
                    }

                    if(this.searchIndex == -1){
                        switch (this.$route.query.channel){
                            case "live":
                                this.searchClassifyArr.forEach((item,index)=>{
                                    if(item.type == 4){
                                        this.searchIndex = index
                                        this.searchClassify = searchClassify = item.type
                                    }
                                })
                                break;
                            case "course":
                                this.searchClassifyArr.forEach((item,index)=>{
                                    if(item.type == 1){
                                        this.searchIndex = index
                                        this.searchClassify = searchClassify = item.type
                                    }
                                })
                                break;
                            case "case":
                                this.searchClassifyArr.forEach((item,index)=>{
                                    if(item.type == 6){
                                        this.searchIndex = index
                                        this.searchClassify = searchClassify = item.type
                                    }
                                })
                                break;
                        }
                    }else{
                        this.searchIndex = 0
                    }

                    // 获取搜索结果
                    this.getSearchContent(searchClassify)
                }
                if (this.recordFlag) {
                    Interface.getData('get', Interface.v4.search_record, {keyword: this.searchText}).then((res) => {

                    })
                }
            })
        },
        getSearchContent(searchClassify){
            Interface.getData('get', Interface.v4.content_select, {
                keyword: this.searchText,
                origin_type: searchClassify,
                page: 1,
                pageSize: 10
            }).then(res => {
                if (res.code == 0) {
                    if (res.data.list && res.data.list.length) {
                        this.showResult = true
                        this.contentShow = false
                        this.showHot = false
                        this.recommend = res.data.list
                        this.searchResultEmpty = false
                    } else {
                        this.searchResultEmpty = true
                        this.showHot = true
                        this.contentShow = true
                        this.showResult = false

                    }
                }
                // 搜索完之后隐藏搜索历史记录
                this.showHistory = false
            })
        },
        onCancel() {},
        // 删除搜索历史
        delConfirm() {
            Interface.getData('delete', Interface.v4.search_del).then(res => {
                if (res.code == 0) {
                    this.historyTag = []
                    this.showHistory = false
                }
            })
        },
        // 点击某个历史搜索
        clickTag(item) {
            this.recordFlag = true
            if (item.title === '展开') {
                this.openAll()
            } else if (item.title === '收起') {
                this.defaultClose()
            } else {
                this.searchText = item.title
                this.autofocus = true
                this.$nextTick(() => {
                    this.showList = false
                })
                this.onSearch()
            }
        },
        // 历史搜索默认收起
        defaultClose() {
            this.$nextTick(() => {
                if (!this.historyTag || !this.historyTag.length) {
                    return
                }
                let offsetLeft = 0
                this.line = 0
                let tags = this.$refs.tagRef
                tags.forEach((item, index) => {
                    if (index === 0) {
                        this.line = 1
                        offsetLeft = item.offsetLeft
                    } else if (item.offsetLeft === offsetLeft) {
                        this.line++
                    }
                    if (this.line > 1) {
                        item.style.marginTop = 12 + 'px'
                    }
                    if (this.line > 2) {
                        item.style.display = 'none'
                        if (item.className === 'chu') {
                            item.style.display = 'inline-block'
                            if (item.offsetLeft < 25) {
                                item.style.marginTop = 12 + 'px'
                            } else {
                                item.style.marginTop = 0 + 'px'
                            }
                        }
                    }
                })
                if (this.line > 2) {
                    this.historyTag.push({ id: 0, title: '展开' })
                    this.$nextTick(() => {
                        if (document.querySelector('.chu').offsetLeft < 25) {
                            document.querySelector('.chu').style.marginTop = 12 + 'px'
                        } else {
                            document.querySelector('.chu').style.marginTop = 0 + 'px'
                        }
                    })
                }
                let index = this.historyTag.findIndex(item => {
                    return item.title === '收起'
                })
                if (index > -1) {
                    this.historyTag.splice(index, 1)
                }
            })
        },
        // 历史搜索展开
        openAll() {
            let tags = this.$refs.tagRef
            let index = this.historyTag.findIndex(item => {
                return item.title === '展开'
            })
            this.historyTag.splice(index, 1)
            this.historyTag.splice(tags.length, 0, { id: 0, title: '收起' })
            tags.forEach((item, index) => {
                item.style.display = 'inline-block'
                if (item.className === 'chu') {
                    if (item.offsetLeft < 25) {
                        item.style.marginTop = 12 + 'px'
                    } else {
                        item.style.marginTop = 0 + 'px'
                    }
                }
            })
        },
        // 点击某个热门搜索
        clickHot(item) {
            this.recordFlag = true
            this.searchText = item.title
            this.autofocus = true
            this.$nextTick(() => {
                this.showList = false
            })
            // 热词点击量
            Interface.getData('get', Interface.v4.hot_click + '/' + item.id + '/view').then(res => {
            })
            this.onSearch()
        },
        // 选中模糊搜索列表的某一个
        selectItem(item) {
            this.searchText = item.title
            this.autofocus = true
            this.$nextTick(() => {
                this.showList = false
            })
            this.onSearch()
        },
        tabClick() {
            this.recordFlag = false
            this.resultPage = 1
            this.resultFinished = false

            console.log(this.searchClassifyArr)
            if(this.searchClassifyArr[0].id != 1){
                this.getSearchContent(this.searchClassifyArr[this.searchIndex].type)
            }else{
                this.onSearch()
            }
        },
        // 用户输入搜索词
        mInput() {
            // 用户输入搜索词时  隐藏搜索历史记录  热门搜索  热门推荐
            this.showHistory = false
            this.showHot = false
            this.contentShow = false
        },
        // 搜索结果分页加载
        onLoad() {
            this.resultPage++
            Interface.getData('get', Interface.v4.content_select, {
                keyword: this.searchText,
                origin_type: this.searchClassify || 0,
                page: this.resultPage,
                pageSize: 10 }).then(res => {
                if (res.code == 0) {
                    this.resultLoading = false
                    if (res.data.list && res.data.list.length) {
                        this.recommend.push(...res.data.list)
                    }
                    this.resultLoading = false
                    if (this.resultPage >= res.data.total_page) {
                        this.resultFinished = true
                    }
                }
            })
        },
        // 内容精选分页加载
        contentLoad() {
            this.contentPage++
            let params = {
                origin_type: '',
                page: this.contentPage,
                pageSize: 10
            }
            Interface.getData('get', Interface.v4.content_select, params).then((res) => {
                if (res.code == 0) {
                    this.contentShow = true
                    if(res.data.list && res.data.list.length) {
                        this.contentList.push(...res.data.list)
                    }
                    this.contentLoading = false
                    if (this.contentPage >= res.data.total_page) {
                        this.contentFinished = true
                    }
                }
            })
        }
    },
    watch: {
        searchText: {
            handler(newVal, oldVal) {
                if (newVal) {
                } else {
                    this.init()
                    this.contentLoad()
                    this.searchResultEmpty = false
                    this.showResult = false
                    this.searchClassify = null
                    this.resultFinished = false
                    this.resultPage = 1
                }
            }
        }
    },

    beforeRouteEnter(to, from, next) {
        to.meta.keepAlive = true
        next(vm => {
            if (from.name == 'home-new') {
                vm.showResult = false
                if (vm.$route.query.search) {
                    vm.searchObj = JSON.parse(vm.$route.query.search)
                    vm.searchText = vm.searchObj.title
                } else {
                    vm.searchText = ''
                }
            }
        })
    },
    mounted() {
        this.init()
        if (this.$route.query.search) {
            this.searchObj = JSON.parse(this.$route.query.search)
            this.searchText = this.searchObj.title
        }
    },
    created() {
        this.searchResultEmpty = false
        if (this.showResult) {
            return
        } else {
            this.contentLoad()
            this.init()
            if (this.$route.query.search) {
                this.searchObj = JSON.parse(this.$route.query.search)
                this.searchText = this.searchObj.title
            }
        }
    },
}
</script>

<style scoped lang="scss">
@import "./index-new.scss";
</style>



// WEBPACK FOOTER //
// src/views/search/index-new.vue